/**
 * Hide Turnstile CAPTCHA until user interacts with the form.
 *
 * Adds .turnstile-hidden to forms on page load, removes it on first interaction.
 * Cloudflare and GF handle everything else — we just toggle visibility.
 *
 * CSS counterpart: src/styles/_forms.sass (search "turnstile-hidden")
 */
(function () {
	document
		.querySelectorAll('.gfield--type-turnstile, .gfield.gfield_turnstile')
		.forEach(function (field) {
			// Don't hide if there's a validation error on the turnstile field
			if (field.querySelector('.validation_message, .gfield_validation_message')) return;

			var form = field.closest('form');
			if (!form || form.classList.contains('turnstile-hidden')) return;
			form.classList.add('turnstile-hidden');

			function show() {
				form.classList.remove('turnstile-hidden');
				form.removeEventListener('focusin', show);
				form.removeEventListener('click', show);
			}
			form.addEventListener('focusin', show, { once: true });
			form.addEventListener('click', show, { once: true });
		});
})();
